<template>
  <div class="accounts">
    <div class="head">
        已为您查询到以下角色
        <van-icon name="cross" class="cross" @click="close"/>
    </div>
    <ul v-if="roles">
        <li v-for="(item,i) in roles" :key="i" :class="{'active': role_id == item.role_id}" @click="choose(item.role_id,item.role_name,item.server_id,item.server_name)">
            <van-image :src="icon" class="icon"/>
            <div class="info">
                <p>{{ item.role_name }}</p>
                <p>{{ item.server_name }}</p>
            </div>
        </li>
    </ul>
    <van-button round color="var(--theme)" class="sell_btn" :disabled="role_id == ''" @click="gotoSell">{{ index == 1 ? '卖道具' : (index == 2 ? '卖角色':'确定') }}</van-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
        app_id: this.selection.app_id,
        account_id: this.selection.account_id,
        account: this.selection.account,
        roles: this.selection.roles,
        icon: this.selection.icon,
        index: this.selection.index,
        from: this.selection.from || '',//来源
        child_user_id: this.selection.child_user_id,
        role_id: '',
        role_name: '',
        server_id: '',
        server_name: ''
    }
  },
  computed: {
    isVerify() {
      return this.$store.getters.isVerify;
    },
  },
  created () {},
  mounted () {},
  methods: {
    close() {
        this.$emit('closeModal')
    },
    choose(role_id,role_name,server_id,server_name) {
        this.role_id = role_id
        this.role_name = role_name
        this.server_id = server_id
        this.server_name = server_name
    },
    gotoSell() {
        if(!this.isVerify) {
            this.$toast({
                message: '请先完成实名认证',
                duration: 2000,
                zIndex: 100000,
                onClose: () => {
                    this.$router.push({
                        name: "user.identity",
                        query: {
                            redirect: this.$route.fullPath
                        }
                    });
                },
            })
            return
        }
        if(this.index == 0 || this.index == 1) {
            this.$emit('closeModal')
            this.$emit('success',{
                role_id: this.role_id,
                role_name:this.role_name,
                server_id:this.server_id,
                server_name:this.server_name
            })
            return
        }
        // this.$filterPop({
        //             type: 'selltype',
        //             direction: 'up',
        //             selection: {
        //                 app_id:this.app_id,
        //                 account_id:this.account_id,
        //                 account: this.account,
        //                 role_id: this.role_id,
        //                 role_name:this.role_name,
        //                 server_id:this.server_id,
        //                 server_name:this.server_name,
        //                 icon: this.icon,
        //                 from:this.from
        //             }
        //         })
        //         return
        this.$Ajax('goods-role/check-role',{
            app_id: this.app_id,
            server_id:this.server_id,
            role_id: this.role_id,
            account_id:this.account_id
        }).then(rs => {
            if(rs.code == 200) {
                // this.$filterPop({
                //     type: 'selltype',
                //     direction: 'up',
                //     selection: {
                //         app_id:this.app_id,
                //         account_id:this.account_id,
                //         account: this.account,
                //         role_id: this.role_id,
                //         role_name:this.role_name,
                //         server_id:this.server_id,
                //         server_name:this.server_name,
                //         icon: this.icon,
                //         from:this.from,
                //         child_user_id: this.child_user_id
                //     }
                // })
                var params = {
                    app_id: this.app_id,
                    account_id:this.account_id,
                    account: this.account,
                    role_id: this.role_id,
                    role_name:this.role_name,
                    server_id:this.server_id,
                    server_name:this.server_name,
                    child_user_id: this.child_user_id
                }
                if(this.from != '') {
                    params.from = this.from
                }
                this.$store.commit('setPuton',JSON.stringify(params))
                setTimeout(() => {
                    this.$router.push({
                        name: 'acc.puton',
                        query: params
                    })
                },100)
            }else {
                this.$Message.error(rs.msg)
            }
        })
    }
  },
  watch: {},
}
</script>

<style lang="less" scoped>
.accounts {
    .head {
        height: 3.6rem;
        line-height: 3.6rem;
        background-color: var(--theme);
        color: #fff;
        text-align: center;
        font-size: 1.6rem;
        position: relative;
        .cross {
            position: absolute;
            right: 1.2rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 1.8rem;
            color: #fff;
            cursor: pointer;
        }
    }
    ul {
        padding: 1.2rem 1.4rem;
        max-height: 28rem;
        overflow-y: auto;
        li {
            height: 9rem;
            background-color: rgba(153, 153, 153, 0.1);
            border-radius: 1rem;
            display: flex;
            align-items: center;
            border: 1px solid rgba(153, 153, 153, 0.1);
            padding: 0 1.6rem;
            margin-bottom: .9rem;
            cursor: pointer;
            &:nth-last-child(1) {
                margin: 0;
            }
            .icon {
                width: 6rem;
                height: 6rem;
                border-radius: 1.2rem;
                overflow: hidden;
                margin-right: 1rem;
            }
            .info {
                flex: 1;
                word-break: break-all;
                overflow: hidden;
                p:nth-child(1) {
                    font-size: 1.8rem;
                    color: #000;
                    margin-bottom: .8rem;
                }
                p:nth-child(2) {
                    font-size: 1.4rem;
                    color: #555;
                }
            }
            &.active{
                border-color: var(--theme);
                background-color: var(--themebgc);
            }
        }
    }
    .sell_btn {
        width: calc(100% - 2.8rem);
        padding: 0;
        font-size: 1.6rem;
        height: 3.2rem;
        margin: 0.6rem auto 1.6rem;
        display: block;
        color: #fff;
        &:disabled {
            background-color: #999 !important;
            border-color: #999 !important;
        }
    }
}
</style>
